exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Rw8ydYwqnl1kZWuBRmZcE{z-index:0}._2Rw8ydYwqnl1kZWuBRmZcE,._2Rw8ydYwqnl1kZWuBRmZcE ._3GcOoBTNmWFAs3rvXwplj-{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1}._2Rw8ydYwqnl1kZWuBRmZcE ._3GcOoBTNmWFAs3rvXwplj-{overflow:hidden;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", ""]);
// Exports
exports.locals = {
	"contentContainer": "_2Rw8ydYwqnl1kZWuBRmZcE",
	"component": "_3GcOoBTNmWFAs3rvXwplj-"
};